import script from "./PulicReportNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./PulicReportNotice.vue?vue&type=script&setup=true&lang=js"

import "./PulicReportNotice.vue?vue&type=style&index=0&id=6e9d5c87&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e9d5c87"]])

export default __exports__